module.exports = __webpack_public_path__ + "img/currency.91d7ef14.png";